export const footerListTitleIndex: { [key: string]: string } = {
  AboutUs: 'features',
  Product: 'support',
  Help: 'communities',
  Study: 'policies',
};
